import React from 'react';

import {
  Table,
  TableCell,
  TableHeader,
  TableRow,
  Text,
  Title,
  Tooltip,
  WrapperFlex,
} from '@unimed-fesp/components';

import { format } from 'date-fns';
import { MdOutlineManageSearch } from 'react-icons/md';
import history from '../../../services/history';
import theme from '../../../styles/theme';
import { InfoDisplayItem } from '../../atoms/InfoDisplayItem';
import EmptyContent from '../../molecules/EmptyContent';
import LoadingSpinner from '../../molecules/LoadingSpinning';
import { CardPersonalInformation, HoverActions } from './styles';

function DadoBeneficiarios({ loading, success, data }) {
  if (loading) {
    return (
      <WrapperFlex column marginBottom={30} fullWidth>
        <Text text="Carregando informações do beneficiário..." />
        <LoadingSpinner />
      </WrapperFlex>
    );
  }

  if (success && data.length > 0) {
    return <InfoBeneficiary data={data[0]} />;
  }

  if (success && data.length === 0) {
    return <EmptyContent />;
  }

  return null;
}
function InfoBeneficiary({ data }) {
  const otherDataSerialized = JSON.parse(data.otherDataSerialized);
  const dependentsSerialized = data.hasDependents
    ? { dependents: JSON.parse(data.dependentsSerialized) }
    : '';

  const beneficiary = {
    ...data,
    ...otherDataSerialized,
    ...dependentsSerialized,
  };

  const sexo = {
    M: 'Masculino',
    F: 'Feminino',
  };
  const formatDate = (date) => {
    const dataFormated = date
      ? format(new Date(date), 'dd/MM/yyyy', {
          timeZone: 'America/Sao_Paulo',
        })
      : '';
    return dataFormated;
  };
  return (
    <WrapperFlex gap={10} column fullWidth>
      <CardPersonalInformation>
        <Title
          color={theme.greenDefault}
          fontSize={20}
          marginTop={10}
          marginBottom={10}
          text="Dados Contrato"
        />
        <WrapperFlex gap={20}>
          <InfoDisplayItem title="Modalidade" content={beneficiary.modality} />
          <InfoDisplayItem title="Termo/Proposta" content={beneficiary.term} />
          <InfoDisplayItem
            title="Código do Beneficiário"
            content={beneficiary.codeTotvs}
          />
        </WrapperFlex>
      </CardPersonalInformation>
      <CardPersonalInformation>
        <Title
          color={theme.greenDefault}
          fontSize={20}
          marginTop={10}
          marginBottom={10}
          text="Dados pessoais"
        />
        <WrapperFlex gap={10}>
          <WrapperFlex column width={500}>
            <InfoDisplayItem
              title="Nome Completo"
              content={beneficiary.beneficiaryName}
            />
            <InfoDisplayItem
              title="Grau Parentesco"
              content={beneficiary.degreeOfKinship}
            />
            <InfoDisplayItem
              title="Nome Social"
              content={beneficiary.nmSocial}
            />
            <InfoDisplayItem title="Nome da Mãe" content={beneficiary.nmMae} />
            <InfoDisplayItem title="Nome do Pai" content={beneficiary.nmPai} />
            <InfoDisplayItem title="Sexo" content={sexo[beneficiary.dsSexo]} />
            <InfoDisplayItem
              title="Estado Civil"
              content={beneficiary.dsEstCivil}
            />
            <InfoDisplayItem
              title="Data Nascimento"
              content={
                beneficiary.beneficiaryBirthday &&
                formatDate(beneficiary.beneficiaryBirthday)
              }
            />
            <InfoDisplayItem
              title="Data Admissão"
              content={
                beneficiary.dtAdmissao && formatDate(beneficiary.dtAdmissao)
              }
            />
            <InfoDisplayItem
              title="Data Inclusão no Plano"
              content={
                beneficiary.dtInclusaoPlano &&
                formatDate(beneficiary.dtInclusaoPlano)
              }
            />
            <InfoDisplayItem title="Data do Evento" />
          </WrapperFlex>
          <WrapperFlex column>
            <InfoDisplayItem title="CEP" content={beneficiary.enCep} />
            <InfoDisplayItem
              title="Endereço"
              content={beneficiary.dsEndereco}
            />
            <InfoDisplayItem title="Bairro" content={beneficiary.enBairro} />
            <InfoDisplayItem title="Estado" content={beneficiary.enUf} />
            <InfoDisplayItem title="Cidade" content={beneficiary.nmCidade} />
            <InfoDisplayItem
              title="Telefone"
              content={beneficiary.nrTelefone1}
            />
            <InfoDisplayItem
              title="Celular"
              content={beneficiary.nrTelefone2}
            />
            <InfoDisplayItem title="Email" content={beneficiary.nmEmail} />
            <InfoDisplayItem
              title="Data de Exclusão"
              content={
                beneficiary.beneficiaryExcludeDate &&
                formatDate(beneficiary.beneficiaryExcludeDate)
              }
            />
            <InfoDisplayItem
              title="Data de Vigência Repasse"
              content={
                beneficiary.dtInclusaoRepasse &&
                formatDate(beneficiary.dtInclusaoRepasse)
              }
            />
          </WrapperFlex>
        </WrapperFlex>
      </CardPersonalInformation>
      <CardPersonalInformation fullWidth>
        <Title
          color={theme.greenDefault}
          fontSize={20}
          marginTop={5}
          marginBottom={10}
          text="Documentações"
        />
        <WrapperFlex gap={10}>
          <WrapperFlex column width={500}>
            <InfoDisplayItem
              title="Código Funcionário"
              content={beneficiary.cdFuncionario}
            />
            <InfoDisplayItem title="CPF" content={beneficiary.cdCpf} />
            <InfoDisplayItem
              title="Nº do Cartão Nacional do SUS"
              content={beneficiary.nrCartaoSus}
            />
            <InfoDisplayItem
              title="Nº Declaração Nasc. Vivo"
              content={beneficiary.nrNascidoVivo}
            />
          </WrapperFlex>
          <WrapperFlex column>
            <InfoDisplayItem
              title="Código Unimed/Cartão"
              content={beneficiary.codeCard}
            />
            <InfoDisplayItem title="RG" content={beneficiary.nrIdentidade} />
            <InfoDisplayItem
              title="País de Emissão (RG)"
              content={beneficiary.ufEmissorIdent}
            />
            <InfoDisplayItem
              title="Órgão Emissor (RG)"
              content={beneficiary.dsOrgaoEmissorIdent}
            />
          </WrapperFlex>
        </WrapperFlex>
      </CardPersonalInformation>
      <CardPersonalInformation fullWidth>
        <Title
          color={theme.greenDefault}
          fontSize={20}
          marginTop={10}
          marginBottom={10}
          text="Informações"
        />
        <WrapperFlex gap={10}>
          <WrapperFlex column width={500}>
            <InfoDisplayItem
              title="Unidade de Atendimento"
              content={`${beneficiary.cdUnidadeAtendimento} - ${beneficiary.nmUnidadeAtendimento}`}
            />

            <InfoDisplayItem
              title="Unidade de Negociação"
              content={`${beneficiary.cdUnidadeAtendimento} - ${beneficiary.nmUnidadeAtendimento}`}
            />
            <InfoDisplayItem
              title="Padrão Cobertura"
              content={beneficiary.dsPadraoCobertura}
            />
            <InfoDisplayItem
              title="Data Falecimento"
              content={
                beneficiary.dtFalecimento &&
                formatDate(beneficiary.dtFalecimento)
              }
            />
            <InfoDisplayItem
              title="Motivo de Cancelamento"
              content={
                beneficiary.cdMotivoCancel &&
                `${beneficiary.cdMotivoCancel} - ${beneficiary.dsMotivoCancel} `
              }
            />
          </WrapperFlex>
          <WrapperFlex column>
            <InfoDisplayItem
              title="Info específica 1 "
              content={beneficiary.cDsEspecifico1}
            />
            <InfoDisplayItem
              title="Info específica 2"
              content={beneficiary.cDsEspecifico2}
            />
            <InfoDisplayItem
              title="Info específica 3"
              content={beneficiary.cDsEspecifico3}
            />
            <InfoDisplayItem
              title="Info específica 4"
              content={beneficiary.cDsEspecifico4}
            />
          </WrapperFlex>
        </WrapperFlex>
      </CardPersonalInformation>
      <CardPersonalInformation fullWidth>
        <Title
          color={theme.greenDefault}
          fontSize={20}
          marginTop={10}
          marginBottom={10}
          text="Grupo Familiar"
        />

        <Table
          head={
            <TableListaHeader
              listNameHeaders={[
                { name: 'Nome', minWidth: 500, maxWidth: 500 },
                { name: 'Grau parentesco' },
                { name: '', minWidth: 30, maxWidth: 30 },
              ]}
            />
          }
        >
          {
            beneficiary.hasDependents &&
              beneficiary.dependents.length >= 1 &&
              beneficiary.dependents.filter(
                (dependents) => !dependents.dtExclusaoPlano
              ).length >= 1 &&
              beneficiary.dependents
                .filter((dependents) => !dependents.dtExclusaoPlano)
                .map((dependent) => {
                  return (
                    <TableRow key={dependent.cdCarteiraUsuario}>
                      <TableCell width={500}>{dependent.nmUsuario}</TableCell>
                      <TableCell>{dependent.tpUsuarioDesc}</TableCell>
                      <TableCell>
                        <WrapperFlex alignCenter justifySpaceEvenly>
                          <Tooltip
                            background={theme.greenDefault}
                            color={theme.bgWhite}
                            text="Detalhes"
                            position="bottom"
                          >
                            <HoverActions
                              onClick={() =>
                                history.push(
                                  `/novo/beneficiarios-nestle/0970${dependent.cdCarteiraUsuario}`
                                )
                              }
                            >
                              <MdOutlineManageSearch
                                size="19"
                                color={theme.colorGray}
                              />
                            </HoverActions>
                          </Tooltip>
                        </WrapperFlex>
                      </TableCell>
                    </TableRow>
                  );
                }) /* : (
            <TableRow>
              <TableCell width={500}>
                {beneficiary.holderBeneficiaryName}
              </TableCell>
              <TableCell>1 - Titular</TableCell>
              <TableCell>
                <WrapperFlex alignCenter justifySpaceEvenly>
                  <Tooltip
                    background={theme.greenDefault}
                    color={theme.bgWhite}
                    text="Detalhes"
                    position="bottom"
                  >
                    <HoverActions
                      onClick={() =>
                        history.push(
                          `/novo/beneficiarios-nestle/${beneficiary.codeCardHolder}`
                        )
                      }
                    >
                      <MdOutlineManageSearch
                        size="19"
                        color={theme.colorGray}
                      />
                    </HoverActions>
                  </Tooltip>
                </WrapperFlex>
              </TableCell>
            </TableRow>
          ) */
          }
        </Table>
      </CardPersonalInformation>
    </WrapperFlex>
  );
}

const TableListaHeader = ({ listNameHeaders }) => {
  return (
    <TableRow>
      {listNameHeaders.map((header) => (
        <TableHeader
          key={header.name}
          minWidth={header.minWidth}
          maxWidth={header.maxWidth}
        >
          {header.name}
        </TableHeader>
      ))}
    </TableRow>
  );
};
export default DadoBeneficiarios;
